export class ObjectBreadcrumb {
  public label: string;
  public url: string;
  public itemId: string;
}
